import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZThirtyData = z.object({
  data: z.array(z.object({
    timestamp: z.string(),
    kpi_value: z.number()
  })),
  CalculatedAt: z.string().optional()
})

const ZDataPoint = z.object({
  name: z.string(),
  asset_type: z.string(),
  count: z.number().nullable(),
  date: z.string(),
  percentage: z.number()
})
export type ThirtyDayDatapoint = z.infer<typeof ZDataPoint>

const ZThirtyDayData = z.object({
  asset_cat: z.string(),
  dataPoint: z.array(ZDataPoint)
})

export type ThirtyDayDataObjWithCategory = z.infer<typeof ZThirtyDayData>

export const ZThirtyDayDataObject = z.object({
  totalCount: z.number(),
  liveData: z.array(ZThirtyDayData),
  CalculatedAt: z.string().optional()
})

export type ThirtyDayDataObject = z.infer<typeof ZThirtyDayDataObject>

export type thirtyDay = z.infer<typeof ZThirtyData>

export async function getThirtyDayData (
  tenantId: string,
  from: string,
  to: string,
  onSuccess: (thirtyDayData: ThirtyDayDataObject, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = 'kpi-service/api/v1/udp/liveData/thirty-days-trend?kpiCategoryId=54c0f6dd-3460-433c-b808-cad310fce27c'
  interceptedAxios.get(url)
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZThirtyDayDataObject.safeParse(response.data.data)
        // istanbul ignore else
        if (parseResponse.success) {
          // istanbul ignore else
          if (parseResponse.data !== null && parseResponse.data !== undefined && parseResponse.data.liveData.length > 0) {
            onSuccess(parseResponse.data, response.status)
          } else {
            onFailure('No Data Present', response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      }
    })
    .catch((error) => {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      const statusCode = error.response ? error.response.status : 500
      onFailure(error.message, statusCode)
    })
}
